export default {"src":"/_next/static/media/lune-icon-hub.586f432a.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};